import script from "./AfiliationInfoForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AfiliationInfoForm.vue?vue&type=script&setup=true&lang=ts"

import "./AfiliationInfoForm.vue?vue&type=style&index=0&id=ccfd3d66&scoped=true&lang=css"
import "./AfiliationInfoForm.vue?vue&type=style&index=1&id=ccfd3d66&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccfd3d66"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QField});
